// Inline SVG icons for the Model graph.
//
// Inline rather than a Phosphor/Lucide dependency: this UI is disposable and
// gets handed to the FE team, so an icon package here just becomes theirs to
// remove. Stroked on currentColor at a 24px viewBox so it inherits text
// colour and scales with `size`. aria-hidden because every icon sits beside
// a real label - announcing it twice is noise for screen readers.
//
// Only the search glyph survives; the rest went with the customer-facing
// view. Disclosure carets are drawn in CSS (.tlx-caret) so open and closed
// are one rotated object rather than two glyphs.

interface IconProps {
  size?: number;
  className?: string;
}

export function Search({ size = 15, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
      className={className}
    >
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </svg>
  );
}
